export function getActiveWorkspacePlans(workspace) {
  if (Array.isArray(workspace?.activePlans) && workspace.activePlans.length > 0) {
    return workspace.activePlans
  }

  if (!Array.isArray(workspace?.plans)) {
    return []
  }

  return workspace.plans.filter((plan) => plan?.isActive)
}

export function isCodeDesignTeamUser(profile) {
  const email = profile?.email || ''
  return (
    email.endsWith('codedesign.app') ||
    email.endsWith('codedesign.ai') ||
    profile?.isAdmin === true
  )
}

export function shouldRenderFreeGenerationBanner({ workspace, profile, loading }) {
  if (loading || !workspace) {
    return false
  }

  const hasActiveWorkspacePlan = getActiveWorkspacePlans(workspace).length > 0
  const hasLegacyPaidPlan = Boolean(profile?.order?.paid)

  return !(hasActiveWorkspacePlan || hasLegacyPaidPlan || isCodeDesignTeamUser(profile))
}
